/**
 * CashMoney Pay panel yardımcıları.
 *
 * Ayarlar `settings` kaydında **değildir** — `provider_configs` satırında tek
 * bir JSON gövdesidir (bkz. backend/services/cashmoney.py). Sırlar
 * (`api_secret`, `webhook_secret`) sunucudan geri dönmez; boş bırakılan sır
 * gönderilmez, yani kayıtlı değer korunur.
 */

export const CASHMONEY_DEFAULTS = {
  enabled: false,
  api_url: 'https://api.cashmoney-pay.com/api/v1/h2h',
  api_key: '',
  api_secret: '',
  webhook_secret: '',
  callback_url: '',
  callback_registered: false,
  deposit_enabled: true,
  withdraw_enabled: true,
  deposit_min_amount: 1,
  deposit_max_amount: 50000,
  withdraw_min_amount: 1,
  withdraw_max_amount: 50000,
};

export const CALLBACK_PATH = '/api/cashmoney/callback';

const SECRET_KEYS = ['api_secret', 'webhook_secret'];

const sameValue = (a, b) => {
  if (typeof a === 'boolean' || typeof b === 'boolean') {
    return Boolean(a) === Boolean(b);
  }
  if (typeof a === 'number' || typeof b === 'number') {
    const left = Number(a ?? 0);
    const right = Number(b ?? 0);
    if (Number.isFinite(left) && Number.isFinite(right)) return left === right;
  }
  return String(a ?? '') === String(b ?? '');
};

/**
 * Sunucuya gönderilecek gövde: yalnızca değişen alanlar. Callback adresi
 * salt okunurdur ve sitenin güncel ödeme kökünden türetilir; kayıttaki değer
 * geride kalmışsa kaydedilirken düzeltilir.
 */
export const changedFields = (current, initial, options = {}) => {
  const { paymentBase = '' } = options;
  const values = current || {};
  const saved = initial || {};
  const payload = {};
  Object.keys(CASHMONEY_DEFAULTS).forEach((key) => {
    if (key === 'callback_url') return;
    const next = values[key];
    if (next === undefined) return;
    if (SECRET_KEYS.includes(key)) {
      if (String(next || '').trim()) payload[key] = String(next).trim();
      return;
    }
    if (!sameValue(next, saved[key])) payload[key] = next;
  });
  if (paymentBase) {
    const url = `${paymentBase}${CALLBACK_PATH}`;
    if (!sameValue(saved.callback_url, url)) payload.callback_url = url;
  }
  return payload;
};
